import { Link } from "react-router-dom";

export const itemRenderer = (item, _options, location) => {
  const styleClass =
    "flex align-items-center cursor-pointer p-menuitem-link text-color border-none";

  return (
    <div className="p-menuitem-content">
      <Link
        className={
          location.pathname === item.url
            ? styleClass + " border-left-2 border-primary bg-primary-50 w-full"
            : styleClass
        }
        to={item.url}
      >
        <span className={`${item.icon} text-primary font-semibold`} />
        <span className="mx-2">{item.label}</span>
      </Link>
    </div>
  );
};

export const itemRendererCitizen = (item, options, location) => {
  const styleClass =
    "flex align-items-center cursor-pointer p-menuitem-link border-none";

  return (
    <div className="p-menuitem-content">
      <Link
        className={
          location.pathname === item.url
            ? styleClass + " border-bottom-2 border-primary w-full"
            : styleClass
        }
        onClick={options.onClick}
        to={item.url}
      >
        <span className={`${item.icon} text-primary font-semibold`} />
        <span className="mx-2">{item.label}</span>
      </Link>
    </div>
  );
};
